import { ROUTES_PATHS } from 'const';
import React from 'react';
import { Link } from 'react-router-dom';

export const LkPopup = ({
  isUser,
  currentUser,
  closeModal,
  logOut,
  openLoginModal,
}) => {
  const handelLogin = () => {
    openLoginModal();
    closeModal();
  };

  return (
    <div className="lkPopup">
      {isUser ? (
        <>
          <p className="lkPopup-text">{currentUser.email}</p>
          <div className="lkPopup-buttons">
            <Link
              to={ROUTES_PATHS.PERSONAL}
              className="lkPopup-buttons__btn-lk"
              onClick={closeModal}
            >
              Личный кабинет
            </Link>
            <button onClick={logOut} className="lkPopup-buttons__btn-logOut">
              Выход
            </button>
          </div>
        </>
      ) : (
        <>
          <p className="lkPopup-text">
            Зарегистрируйтесь, чтобы видеть историю своих заказов и максимально
            быстро их повторять
          </p>
          <div className="lkPopup-buttons">
            <Link
              to={ROUTES_PATHS.REGISTRATION}
              className="lkPopup-buttons__btn-lk"
              onClick={closeModal}
            >
              Регистрация
            </Link>
            <Link
              to={ROUTES_PATHS.FAST_REGISTRATION}
              className="lkPopup-buttons__btn-lk"
              onClick={closeModal}
            >
              Быстрая регистрация
            </Link>
            <button
              id="lkPopup-buttons__btn-signIn"
              className="lkPopup-buttons__btn-signIn"
              onClick={handelLogin}
            >
              Вход
            </button>
          </div>
        </>
      )}
    </div>
  );
};
